export default __webpack_public_path__ + "static/media/exito_front.af3d8d0b.svg";